import axios from 'axios';
import Constants from '@/constants';
import StreetData from '@/models/StreetData';

class ProductService {
    constructor() {

    }

  
    async getDetail(id) {
        console.log('productService::getDetail ', id)
        var query = 'SELECT *';
        query += 'FROM realestate.products ';
        query += 'WHERE id=' + id + ';';

        var url = Constants.HOST_URL + 'runSelectQuery?query=' + query;
        var response = await axios.get(url);
        if(!response.data || response.data.length != 1) {
            alert('Error while downloading record ' + id);
            return;
        }

        query = `SELECT product_id, JSON_OBJECTAGG(updated_at, images) as images FROM (SELECT product_id, updated_at, GROUP_CONCAT(url) AS images FROM realestate.products JOIN realestate.product_images ON realestate.products.id = realestate.product_images.product_id WHERE product_id=${id} GROUP BY updated_at) AS images_table GROUP BY product_id;`
        url = Constants.HOST_URL + 'runSelectQuery?query=' + query;
        var responseImages = await axios.get(url);

        console.log({...response.data[0], ...responseImages.data[0]});
        return {...response.data[0], ...responseImages.data[0]}
    }

    async updateProductColumn(productId, column, value, type) {
        var query = '';

        if(type === 'text') {
            query = `UPDATE realestate.products SET ${column}='${value}' WHERE id=${productId};`;
        } else if(type === 'number' || type === 'boolean') {
            query = `UPDATE realestate.products SET ${column}=${value} WHERE id=${productId};`;
        }

        var url = Constants.HOST_URL + 'runUpdateQuery?query=' + query;
        var response = await axios.get(url);
        if(!response.data) {
            alert('Error while downloading record ' + id);
            return;
        }

        console.log(response.data[0]);
        return response.data[0]
    }

    async deleteProductById(id) {
        var query = `DELETE FROM realestate.products WHERE id =${id}`;

        var url = Constants.HOST_URL + 'runInsertQuery?query=' + query;

        try {
            var response = await axios.get(url);
            console.log(response.data);
        }
        catch (e) {
            alert(e);
        }
    }

    async updateGroupProducts(productIds, column, value, type) {
        var query = '';

        var ids = productIds.join();

        if(type === 'text') {
            query = `UPDATE realestate.products SET ${column}='${value}' WHERE id IN (${ids});`;
        } else if(type === 'number') {
            query = `UPDATE realestate.products SET ${column}=${value} WHERE id IN (${ids});`;
        }

        var url = Constants.HOST_URL + 'runUpdateQuery?query=' + query;
        var response = await axios.get(url);
        if(!response.data) {
            alert('Error while downloading record ' + id);
            return;
        }

        console.log(response.data[0]);
        return response.data[0]
    }

    async deleteGroupProducts(productIds) {
        var ids = productIds.join();

        var query = `DELETE FROM realestate.products WHERE id IN (${ids})`;

        var url = Constants.HOST_URL + 'runDeleteQuery?query=' + query;
        
        try {
            var response = await axios.get(url);
            console.log(response.data);
        }
        catch (e) {
            alert(e);
        }
    }

    async getProducts(params = {}) {
        const { page = 1, limit = 20, filters = [] } = params;
        const offset = (page - 1) * limit;
        const tableName = 'realestate.products'; // Use the correct table name
        
        // Helper function to check if a value is meaningful (consistent with GenericTableView)
        const isMeaningfulValue = function(val) {
            if (val === null || val === undefined) return false;
            if (typeof val === 'string' && val.trim() === '') return false;
            if (Array.isArray(val) && val.length === 0) return false;
            return true;
        };
        
        // Build where conditions from filters
        let whereConditions = [];
        if (filters && filters.length > 0) {
            filters.forEach(filter => {
                // Number range filters should be handled regardless of `value`
                if (filter.type === 'number') {
                    const fromVal = isMeaningfulValue(filter.from) ? Number(filter.from) : null;
                    const toVal = isMeaningfulValue(filter.to) ? Number(filter.to) : null;

                    if (fromVal !== null) {
                        whereConditions.push(`${filter.col} >= ${fromVal}`);
                    }
                    if (toVal !== null) {
                        whereConditions.push(`${filter.col} <= ${toVal}`);
                    }
                    return; // handled
                }

                // Multi-select filters
                if (filter.type === 'multi-select' && isMeaningfulValue(filter.value) && filter.value.length > 0) {
                    const values = filter.value.map(v => `'${v}'`).join(',');
                    whereConditions.push(`${filter.col} IN (${values})`);
                    return;
                }

                // The rest of filters depend on a meaningful scalar `value`
                if (isMeaningfulValue(filter.value)) {
                    if (filter.type === 'text') {
                        whereConditions.push(`UPPER(${filter.col}) LIKE UPPER('%${filter.value}%')`);
                    } else if (filter.type === 'select') {
                        whereConditions.push(`${filter.col} = '${filter.value}'`);
                    } else if (filter.type === 'boolean') {
                        if (filter.value === 'true' || filter.value === true) {
                            whereConditions.push(`${filter.col} = true`);
                        }
                    }
                }
            });
        }

        let whereClause = '';
        if (whereConditions.length > 0) {
            whereClause = 'WHERE ' + whereConditions.join(' AND ');
        }

        // Count query
        const countQuery = `
            SELECT COUNT(*) as total 
            FROM ${tableName} 
            ${whereClause}
        `;

        // Data query
        const dataQuery = `
            SELECT * 
            FROM ${tableName} 
            ${whereClause}
            ORDER BY date DESC
            LIMIT ${limit} OFFSET ${offset}
        `;

        try {
            // Get total count
            const countUrl = Constants.HOST_URL + 'runSelectQuery?query=' + encodeURIComponent(countQuery);
            const countResponse = await axios.get(countUrl);
            const total = countResponse.data[0]?.total || 0;

            // Get data
            const dataUrl = Constants.HOST_URL + 'runSelectQuery?query=' + encodeURIComponent(dataQuery);
            const dataResponse = await axios.get(dataUrl);
            const data = dataResponse.data || [];

            return {
                data,
                total,
                page,
                limit
            };
        } catch (error) {
            console.error('Error fetching products:', error);
            throw error;
        }
    }

    async getProductByStreetCode(street_code, new_code) {
        var query = 'SELECT id, code ';
        query += 'FROM realestate.products ';
        query += "WHERE code LIKE '%"+new_code+"%' order by code asc";

        var encoded_query = encodeURI(query)
        var url = Constants.HOST_URL + 'runSelectQuery?query=' + encoded_query;
        var response = await axios.get(url);
        if(!response.data ) {
            alert('Error while querying getProductByStreetCode');
            return;
        }

        return response.data;
    }

    convertFromStatusTextToProductPrefix(status_text) {
        switch (status_text) {
          case 'Đang bán':
            return 'B'
            break;
  
          case 'Bán hoặc Cho thuê':
            return 'BT'
            break;
  
          case 'Treo bảng':
            return 'B'
            break;
  
          case 'Đã bán':
            return 'B'
            break;
  
          case 'Ngưng bán':
            return 'B'
            break;
  
          case 'Cho thuê':
            return 'T'
            break;
  
          case 'Ngưng cho thuê':
            return 'T'
            break;
        
          default:
            return ''
            break;
        }        
      }

      async generateNewProductCode(productDetail) {
        // Generate a new product code based on street_code, status, and a unique increasing number.
        // Structure of the new code: <status>.<new_street_shortform>.<increasing_number>
    
        // Find the short-form of the street name from StreetData
        const street = StreetData.street.find(street => street.code === productDetail.street_code);
        const newStreetCode = street ? street.street_code : '';
    
        // Convert status to its corresponding prefix (e.g., 'Bán' -> 'B', 'Cho thuê' -> 'T')
        const statusCode = this.convertFromStatusTextToProductPrefix(productDetail.status);
    
        // Get existing product codes with the same street code
        const existingCodes = await this.getProductByStreetCode(productDetail.street_code, newStreetCode);
        console.log('productService::generateNewProductCode::existingCodes', existingCodes);
    
        // Initialize the unique increasing number
        let increasingNumber = 1;
        let newProductCode = `${statusCode}.${newStreetCode}.${increasingNumber}`;
    
        // Generate a new product code ensuring uniqueness
        while (existingCodes.some(code => code.code.includes(`${newStreetCode}.${increasingNumber}`))) {
            console.log('ProductService::>', `${newStreetCode}.${increasingNumber}`, 'existed.');
            increasingNumber += 1;
            newProductCode = `${statusCode}.${newStreetCode}.${increasingNumber}`;
        }
    
        console.log('ProductService::new product code:', newProductCode);
    
        return newProductCode;
    }

  }
  
  
export default ProductService;